//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseImporter.js";
let d=[[[0,"BuildingControls",1,0],[0,"CollapsePRVsList",1,0],[0,"Deltax",1,0],[0,"Deltay",1,0],[0,"Deltaz",1,0],[0,"Electrical",1,0],[0,"ExcludeElementClassifications",1,0],[0,"ExcludePRVsList",1,0],[0,"FileOpenFlag",1,0],[0,"FlattenAssembly",1,0],[0,"Hvac",1,0],[0,"ImportFacetsAsConvergentGeometryList",1,0],[0,"ImportFacetsAsPreciseGeometryList",1,0],[0,"ImportFacetsAsXTBrepOrConvergent",1,0],[0,"ImportTo",1,0],[0,"ImportToTeamcenter",1,0],[0,"ImportTooFarHandlingMethod",1,0],[0,"Messages",1,0],[0,"MoveModelData",1,0],[0,"Optimize",1,0],[0,"PlumbingFireProtection",1,0],[0,"ProductExtension",1,0],[0,"RotateAroundZByDegrees",1,0],[0,"SettingsFile",1,0],[0,"SharedBldgServicesElements",1,0],[0,"SharedBuildingElements",1,0],[0,"SharedComponentElements",1,0],[0,"SharedFacilitiesElements",1,0],[0,"ShowInformationWindowFlag",1,0],[0,"StructuralAnalysis",1,0],[0,"StructuralElements",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.IfcImporter = class extends SPLM.BaseImporter{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.IfcImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.IfcImporter.ImportToOption = Object.freeze({
    "WorkPart" : "WorkPart", "NewPart" : "NewPart"});

SPLM.IfcImporter.ImportFacetsAsXTBrepOrConvergentEnum = Object.freeze({
    "XTBrep" : "XTBrep", "ConvergentBodies" : "ConvergentBodies"});

SPLM.IfcImporter.ImportTooFarHandlingMethodEnum = Object.freeze({
    "Insertnode" : "Insertnode", "None" : "None"});

SPLM.IfcImporter.MoveDataEnum = Object.freeze({
    "ByDeltamm" : "ByDeltamm", "To000" : "To000"});

SPLM.IfcImporter.MessageEnum = Object.freeze({
    "None" : "None", "Informational" : "Informational", "Warning" : "Warning", "Error" : "Error", "Debug" : "Debug", "All" : "All"});

export default SPLM;